import { render, staticRenderFns } from "./SensorPill.vue?vue&type=template&id=128d6c30"
import script from "./SensorPill.vue?vue&type=script&lang=js"
export * from "./SensorPill.vue?vue&type=script&lang=js"
import style0 from "./SensorPill.vue?vue&type=style&index=0&id=128d6c30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports